<template>
    <el-container class="FileManager"
                  style="height: 900px; border: 1px solid #eee; position: relative"
                  :class="(merge.showMergeCompile || showDocumentTypeModel || showSignatureChain || sendSigningRequestModal || changeDocumentOwnershipModal) ? 'fin-z-50' : 'fin-z-0'">
        <el-aside
            v-show="!isReferrer || getPermissionByName('view all applications')"
            width="200px"
            style="background-color: rgb(238, 241, 246)"
        >
            <el-menu :default-openeds="['2']">
                <el-menu-item index="1" @click="handleChange('closeall')">
                    <i class="el-icon-folder"></i>
                    Folders
                </el-menu-item>
                <el-submenu index="2">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        Actions
                    </template>
                    <el-menu-item index="2-1" @click="merge.active = !merge.active"
                                  :class="{ 'is-merge': this.merge.active }">
                        <el-badge
                            :value="merge.items.length"
                            class="merge-item-count"
                            :class="{ nilCount: merge.items.length == 0 }"
                        >
                            Merge / Reduce Files
                        </el-badge>
                    </el-menu-item>
                    <el-menu-item index="2-2" v-if="merge.active" class="merge-shortcut-actions">
                        <el-button :style="{ height: '100%' }" type="success" plain icon="el-icon-check"
                                   @click="mergeNow()">
                            Continue
                        </el-button>
                        <el-button
                            :style="{ height: '100%' }"
                            type="default"
                            icon="el-icon-close"
                            @click="cancelMerge"
                        ></el-button>
                    </el-menu-item>
                    <!-- <el-menu-item index="2-3" @click="() => { this.sendSigningRequestModal = true; this.loadingSigningRequest = false;}">Signing Request</el-menu-item> -->
                </el-submenu>
                <el-menu-item
                    @click="
                        trashView = true
                        folderView = false
                    "
                >
                    <el-badge :value="trash.length" class="trash-item-count" :class="{ nilCount: trash.length == 0 }">
                        <i class="el-icon-delete"></i>
                    </el-badge>
                    Trash
                </el-menu-item>
            </el-menu>
        </el-aside>
        <el-container
            v-if="folderView"
            style="position: relative"
            v-loading="getDocumentsFinished"
            element-loading-text="Fetching Documents..."
            element-loading-background="rgba(36, 147, 239, 0.4)"
        >
            <multipane class="document-panel" layout="vertical" :style="{ height: '100%', flexGrow: 1 }">
                <div
                    class="file-preview file-list list"
                    :style="{ width: '50%', minWidth: '50%' }"
                    :class="{ 'w-100': openFolder === 200 || !previewDocument }"
                >
                    <div class="search-wrapper panel-heading col-sm-12">
                        <el-input placeholder="Search files and folders..." v-model="searchQuery" clearable></el-input>
                    </div>
                    <el-collapse @change="handleChange" :value="openFolder">
                        <el-collapse-item
                            v-if="group"
                            :class="{ droppable: droppable == index }"
                            :key="index"
                            v-for="(group, index) in documents.keys()"
                            :name="index"
                            :style="`--file-preview-scoll: ${folderCalc}px;`"
                        >
                            <template slot="title">
                                <div
                                    class="file-wrapper"
                                    @click="previewFolder(group)"
                                    @drop="onDrop($event, group)"
                                    @dragover.prevent="droppable = index"
                                    @dragleave.prevent="droppable = null"
                                >
                                    <div class="file-item folder">
                                        <div class="icon-item">
                                            <el-badge :value="documents.get(group).length" class="item">
                                                <font-awesome-icon
                                                    v-if="openFolder !== index"
                                                    :icon="['fas', 'folder']"
                                                    @mousedown.stop
                                                />
                                                <font-awesome-icon
                                                    v-if="openFolder === index"
                                                    :icon="['fas', 'folder-open']"
                                                    @mousedown.stop
                                                />
                                            </el-badge>
                                        </div>
                                        <div class="item-name">
                                            <span class="name">{{ group }} DOCUMENTS</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div class="row mb-2 mt-2 pb-2 px-3 w-100 border-bottom">
                                <div class="col-5">
                                    <h4>File</h4>
                                </div>
                                <div class="col-3">
                                    <h4>Type</h4>
                                </div>
                                <div class="col-2">
                                    <h4>Status</h4>
                                </div>
                                <div class="col-2 text-right">
                                    <h4>Actions</h4>
                                </div>
                            </div>
                            <div
                                class="file-wrapper file-item"
                                v-for="(item, index) in documents.get(group)"
                                :key="`${item.id}-${index}`"
                                :ref="`${group}-${index}`"
                                draggable
                                @dragstart="startDrag($event, item)"
                            >
                                <div
                                    class="file-item row no-gutters"
                                    v-if="_.get(item, 'document_type.name') != 'Signature Summary'"
                                    @click="merge.active ? select(`select-${item.id}-${index}`) : previewFile(item, group, index)"
                                    :class="{ selected: isSelected(item) }"
                                >
                                    <input
                                        :ref="`select-${item.id}-${index}`"
                                        type="checkbox"
                                        v-model="merge.items"
                                        v-show="false"
                                        v-if="merge.active"
                                        :value-key="item.id"
                                        :value="item"
                                    />
                                    <div class="col-5 d-flex align-items-center">
                                        <div class="icon-item" :class="documentStatuses[item.status]">
                                            <font-awesome-layers full-width class="fa-2x">
                                                <font-awesome-icon :icon="['fas', 'file']"/>
                                                <font-awesome-layers-text
                                                    class="fa-inverse"
                                                    transform="shrink-11.5"
                                                    :value="item.filename ? item.filename.split('.').pop() : 'doc'"
                                                    style="font-weight: 400"
                                                />
                                            </font-awesome-layers>
                                        </div>
                                        <div class="item-name">
                                            <span class="name" :class="{ pending: !item.url }">
                                                <span
                                                    v-b-tooltip.hover.top="item.url ? item.filename : 'Upload Pending'">
                                                    {{ item.url ? item.name : "Upload Pending" }}
                                                </span>
                                                <el-tooltip class="item" effect="dark" content="Edit filename"
                                                            placement="top">
                                                    <button
                                                        class="showonhover amb-icon-btn ml-2"
                                                        type="button"
                                                        v-if="item.uploaded"
                                                        @click.stop="renameFilename(item)"
                                                    >
                                                        <font-awesome-icon :icon="['fas', 'pen']" @mousedown.stop/>
                                                    </button>
                                                </el-tooltip>
                                            </span>
                                            <span class="item-status" v-if="item.uploader_name && item.url">
                                                <el-tag @click.stop="changeDocumentOwnershipModelOpen(item)"
                                                        size="small">
                                                    {{ item.uploader_name }}
                                                </el-tag>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <span class="item-status">
                                            <el-tooltip
                                                class="item"
                                                effect="dark"
                                                :content="item.document_type ? item.document_type.name : ''"
                                                placement="top"
                                            >
                                                <el-tag
                                                    size="small"
                                                    @click.stop="
                                                        item.document_type && item.document_type.name === 'Signature Summary'
                                                            ? ''
                                                            : changeDocumentTypeModal(item)
                                                    "
                                                >
                                                    {{
                                                        item.document_type ? item.document_type.name : "Select Document Type"
                                                    }}
                                                </el-tag>
                                            </el-tooltip>
                                        </span>
                                    </div>
                                    <div class="col-2">
                                        <span class="item-status" v-if="item.url">
                                            <el-dropdown @command="setStatus" trigger="click">
                                                <span class="el-dropdown-link">
                                                    <el-tag size="small" :type="documentStatuses[item.status]">
                                                        {{ item.status }}
                                                    </el-tag>
                                                </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item
                                                        v-for="(color, status) in documentStatuses"
                                                        :key="status"
                                                        :command="status"
                                                        :document="item"
                                                    >
                                                        {{ status }}
                                                    </el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </span>
                                        <span class="item-status" v-else>
                                            <el-tag size="small" :type="documentStatuses[item.status]">{{
                                                    item.status
                                                }}</el-tag>
                                        </span>
                                    </div>
                                    <div class="col-2">
                                        <div class="actions">
                                            <!-- <a class="action"
                                              v-if="pairedHash(item) && _.get(item, 'document_type.document_type') === 'signed'"
                                              @click.stop="openSignatureChain(item)">
                                              <el-tooltip class="item" effect="dark" content="View document signature chain" placement="top">
                                                <font-awesome-icon :icon="['fas', 'link']"  @mousedown.stop />
                                              </el-tooltip>
                                            </a> -->
                                            <a
                                                class="action"
                                                v-if="pairedHash(item) && _.get(item, 'document_type.document_type') === 'signed'"
                                                @click.stop="previewFile(pairedHash(item), group, index)"
                                                target="_blank"
                                            >
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="
                                                        _.get(item, 'document_type.name') !== 'Signature Summary'
                                                            ? `View signing certificate`
                                                            : `View signed Document`
                                                    "
                                                    placement="top"
                                                >
                                                    <font-awesome-layers full-width @mousedown.stop>
                                                        <font-awesome-icon :icon="['far', 'file']"/>
                                                        <font-awesome-icon
                                                            :icon="
                                                                item.document_type.name !== 'Signature Summary'
                                                                    ? ['fas', 'certificate']
                                                                    : ['fas', 'signature']
                                                            "
                                                            transform="down-8 right-7"
                                                        />
                                                    </font-awesome-layers>
                                                </el-tooltip>
                                            </a>
                                            <a
                                                class="action"
                                                v-if="item.url"
                                                @click.stop="previewFile(item, group, index)"
                                                target="_blank"
                                            >
                                                <font-awesome-layers full-width @mousedown.stop>
                                                    <font-awesome-icon :icon="['far', 'file']"/>
                                                    <font-awesome-icon :icon="['fas', 'search']"
                                                                       transform="down-8 right-7"/>
                                                </font-awesome-layers>
                                            </a>
                                            <file-upload
                                                class="action"
                                                :modal="true"
                                                v-if="
                                                    _.get(item, 'document_type.name') != 'Signature Summary' &&
                                                    _.get(item, 'document_type.name') != 'Digitally Signed Document' &&
                                                    _.get(item, 'document_type.name') != 'Pending Signed Document'
                                                "
                                                :endpoint="`/api/application/conditioning/${$store.getters.appId}/document/${item.id}`"
                                                :backend="true"
                                                label="Drop documents here to upload <b><em>or</em></b> <span style='text-decoration: underline;'>click to browse</span>"
                                                :icon="true"
                                            />
                                            <el-popconfirm
                                                confirmButtonText="Trash it!"
                                                cancelButtonText="No, Thanks"
                                                icon="el-icon-info"
                                                iconColor="red"
                                                title="Are you sure to trash this?"
                                                @confirm="removeDocument(item)"
                                            >
                                                <div slot="reference" class="action trash" @click.stop="">
                                                    <font-awesome-icon :icon="['fas', 'trash']" @mousedown.stop/>
                                                </div>
                                            </el-popconfirm>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <multipane-resizer v-show="previewDocument" style="z-index: auto"></multipane-resizer>
                <div v-if="previewDocument" class="preview-panel p-3" :style="{ flexGrow: 1, zIndex: 'auto' }">
                    <DocumentPreview
                        v-if="previewDocument"
                        v-bind="{ previewDocument, documentStatuses, documentTypes }"
                        :key="previewDocument.id"
                        @closePreview="previewDocument = ''"
                        @uploadLineFile="uploadLineFile"
                    />
                </div>
            </multipane>
        </el-container>
        <el-container
            class="d-block"
            v-if="trashView && !folderView"
            :style="{ height: '100%', flexGrow: 1, backgroundColor: '#fff', overflowY: 'scroll' }"
        >
            <div class="row mb-2 mt-2 pb-2 px-3 w-100 border-bottom">
                <div class="col-11">
                    <h4>File</h4>
                </div>
                <div class="col-1 text-right">
                    <h4>Actions</h4>
                </div>
            </div>
            <div class="file-preview file-list list">
                <div class="file-wrapper file-item" v-for="(item, index) in trash" :key="`${item.id}-${index}`">
                    <div class="file-item" :class="{ selected: isSelected(item) }">
                        <div class="col-11 d-flex align-items-center">
                            <div class="icon-item" :class="documentStatuses[item.status]">
                                <font-awesome-layers full-width class="fa-2x">
                                    <font-awesome-icon :icon="['fas', 'file']"/>
                                    <font-awesome-layers-text
                                        class="fa-inverse"
                                        transform="shrink-11.5"
                                        :value="item.filename ? item.filename.split('.').pop() : 'doc'"
                                        style="font-weight: 400"
                                    />
                                </font-awesome-layers>
                            </div>
                            <div class="item-name">
                                <span class="name" :class="{ pending: !item.url }">
                                    {{ item.url ? item.filename : "Upload Pending Placeholder" }}
                                </span>
                            </div>
                        </div>
                        <div class="col-1">
                            <div class="actions">
                                <el-popconfirm
                                    confirmButtonText="Restore now!"
                                    cancelButtonText="No, Thanks"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    title="Are you sure to restore this?"
                                    @confirm="restoreDocument(item)"
                                >
                                    <div slot="reference" class="action trash" @click.stop="">
                                        <font-awesome-icon :icon="['fas', 'trash-restore']" @mousedown.stop/>
                                    </div>
                                </el-popconfirm>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-container>
        <el-dialog
            title="Set Document Type"
            :visible.sync="showDocumentTypeModel"
            append-to-body
            width="500px"
            custom-class="set-document-type"
        >
            <el-select
                v-model="newDocumentCategory"
                value-key="id"
                :placeholder="selectedDocument.document_type ? selectedDocument.document_type.name : 'Select Document Type'"
                placeholder="Select"
                class="w-100"
                filterable
                popper-class="document-types"
            >
                <el-option-group v-for="(group, index) in documentTypes.keys()" :key="`option-${group}-${index}`"
                                 :label="group">
                    <el-option
                        v-for="(item, index) in documentTypes.get(group)"
                        :key="`value-${item.id}-${index}`"
                        :label="`${item.name}`"
                        :value="item"
                    >
                        <span :title="item.name">{{ item.name }}</span>
                    </el-option>
                </el-option-group>
            </el-select>
            <br/>
            <br/>
            <el-checkbox v-model="renameDocument">Rename Document?</el-checkbox>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showDocumentTypeModel = false">Cancel</el-button>
                <el-button type="primary" @click="changeDocumentType">Confirm</el-button>
            </span>
        </el-dialog>

        <x-modal v-if="showSignatureChain" @close="closeSignatureChain" @cancel="closeSignatureChain">
            <div slot="title">Signature chain and status</div>
        </x-modal>

        <x-modal
            width="650"
            :loading="loadingSigningRequest"
            v-if="sendSigningRequestModal"
            @close="sendSigningRequestModal = false"
            @cancel="sendSigningRequestModal = false"
            @ok="sendSigningRequestEmail = true"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Send a Signing Request</div>
            <div class="container" style="max-height: 50vh; overflow-y: scroll">
                <create-signing-request-message
                    :documents="docDocuments"
                    @loading="loadingSigningRequest"
                    @emailSent="resetSigningRequestEmail"
                    :sendEmailTrigger="sendSigningRequestEmail"
                />
            </div>
        </x-modal>

        <el-dialog
            :class="`merge-dialog`"
            title="Merge / Reduce Selected Files"
            :visible.sync="merge.showMergeCompile"
            :modal="false"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Merge / Reduce Selected
                Files
            </div>
            <div style="max-height: 50vh; overflow: hidden; overflow-y: scroll">
                <el-input placeholder="Filename" v-model="merge.name" class="w-100 mb-2"></el-input>
                <el-select
                    v-model="merge.newDocumentCategory"
                    value-key="id"
                    placeholder="Select Document Type"
                    class="w-100 mb-3"
                    filterable
                    popper-class="document-types"
                >
                    <el-option-group
                        v-for="(group, index) in documentTypes.keys()"
                        :key="`option-${group}-${index}`"
                        :label="group"
                    >
                        <el-option
                            v-for="(item, index) in documentTypes.get(group)"
                            :key="`value-${item.id}-${index}`"
                            :label="`${item.name}`"
                            :value="item"
                        >
                            <span :title="item.name">{{ item.name }}</span>
                        </el-option>
                    </el-option-group>
                </el-select>
                <draggable tag="ul" :list="merge.items" class="list-group mb-3">
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                        v-for="(element, idx) in merge.items"
                        :key="idx"
                    >
                        {{ element.filename }}
                        <el-button
                            :style="{ height: '100%' }"
                            type="default"
                            icon="el-icon-close"
                            @click="removeAt(idx)"
                        ></el-button>
                    </li>
                </draggable>
                <el-checkbox
                    v-if="merge.items.length > 1"
                    v-model="merge.remove"
                    label="Delete selected after merge?"
                    border
                ></el-checkbox>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="merge.showMergeCompile = false">Cancel</el-button>
                <el-button type="success" @click="compileDocuments">Let's Do This!</el-button>
            </span>
        </el-dialog>

        <x-modal
            :width="650"
            v-if="changeDocumentOwnershipModal == true"
            @cancel="changeDocumentOwnershipModal = false"
            @close="changeDocumentOwnershipModal = false"
            @ok="changeDocumentOwnershipSubmit"
            :draggable="true"
            :resizable="true"
            :loading="changeDocumentOwnershipModalLoading"
            :okDisabled="changeDocumentOwnershipModalLoading"
            okText="Change Document Ownership"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Change Document Ownership
            </div>
            <el-select v-model="newDocumentOwner" placeholder="Select New Document Owner" style="width: 100%">
                <el-option
                    v-for="documentOwner in documentOwners"
                    :key="documentOwner.value"
                    :value="documentOwner"
                    :label="documentOwner.label"
                ></el-option>
            </el-select>
        </x-modal>
    </el-container>
</template>

<script>
import {mapGetters} from "vuex"

function groupBy(list, keyGetter) {
    const map = new Map()
    list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
            map.set(key, [item])
        } else {
            collection.push(item)
        }
    })
    return map
}

import draggable from "vuedraggable"

export default {
    name: "FileManager",
    components: {draggable},
    props: ["fileTypes"],
    data() {
        return {
            searchQuery: null,
            loading: false,
            folderView: true,
            trashView: false,
            documents: new Map(),
            trash: [],
            preview: "",
            previewDocument: "",
            documentStatuses: {
                Approved: "success",
                Pending: "warning",
                Rejected: "danger",
            },
            showDocumentTypeModel: false,
            selectedGroup: "",
            selectedDocument: {},
            newDocumentCategory: {},
            folderCalc: 0,
            openFolder: [200],
            renameDocument: true,
            droppable: null,
            merge: {
                active: false,
                items: [],
                remove: false,
                showMergeCompile: false,
                newDocumentCategory: {},
            },
            sendSigningRequestModal: false,
            sendSigningRequestEmail: false,
            loadingSigningRequest: false,
            getDocumentsFinished: true,
            showSignatureChain: false,
            currentSignatureChain: {},
            chain: {},
            newDocumentOwner: {},
            changeDocumentOwnershipModal: false,
            changeDocumentOwnershipModalLoading: false,
        }
    },
    computed: {
        ...mapGetters({
            docDocuments: "documents/all",
            isReferrer: "user_roles/is_referrer",
            getPermissionByName: "user/getPermissionByName",
        }),
        documentOwners() {
            let brokerId = this.$store.getters.broker_id
            let broker = this.$store.getters["options/brokers"].find((x) => x.value == (brokerId || ""))
            let applicants = this.$store.getters["application/applicants"]

            let documentOwners = applicants.map((applicant) => {
                return {
                    backend: false,
                    value: applicant.id,
                    label: applicant.full_name,
                }
            })

            if (broker) {
                documentOwners.push({
                    backend: true,
                    value: broker.value,
                    label: broker.label + " (Broker)",
                })
            }

            return documentOwners
        },
        documentTypes() {
            return groupBy(this.fileTypes, (doc) => {
                return (
                    (doc.document_type && doc.document_type != "null") || undefined ? doc.document_type : "others"
                ).toUpperCase()
            })
        },
        resultQuery() {
            if (this.searchQuery) {
                return this.docDocuments.filter((item) => {
                    return this.searchQuery
                        .toLowerCase()
                        .split(" ")
                        .every((v) => {
                            if (item.doc_category) {
                                if (item.doc_category.toLowerCase().includes(v)) {
                                    return item
                                }
                            }
                            if (item.uploader_name) {
                                if (item.uploader_name.toLowerCase().includes(v)) {
                                    return item
                                }
                            }
                            if (item.filename) {
                                if (item.filename.toLowerCase().includes(v)) {
                                    return item
                                }
                            }
                            if (item.document_type && item.document_type.name) {
                                if (item.document_type.name.toLowerCase().includes(v)) {
                                    return item
                                }
                            }
                            return
                        })
                })
            } else {
                return this.docDocuments
            }
        },
    },
    watch: {
        changeDocumentOwnershipModal: {
            handler() {
                this.newDocumentOwner = {}
            },
        },
        resultQuery: {
            deep: true,
            immediate: true,
            handler() {
                let documents = groupBy(this.resultQuery, (doc) => {
                    if (_.get(doc, "document_type.name") != "Signature Summary") {
                        return (
                            doc.document_type && doc.document_category != "markup"
                                ? doc.document_type.document_type || "Customer"
                                : "Other"
                        ).toUpperCase()
                    }
                })

                this.documents = new Map([...documents.entries()].sort())
                this.getDocumentsFinished = false
                this.folderCalc = this.documents.size * 62
            },
        },
    },
    created() {
    },
    mounted() {
        this.$bus.$on("filemanager::document::rename", this.renameFilename)
        this.$bus.$on("filemanager::trash::fetch", this.getTrashed)
        this.getTrashed()
    },
    updated() {
    },
    activated() {
    },
    methods: {
        changeDocumentOwnershipModelOpen(item) {
            this.selectedDocument = item
            this.changeDocumentOwnershipModal = true
            this.changeDocumentOwnershipModalLoading = false
        },
        changeDocumentOwnershipSubmit() {
            this.changeDocumentOwnershipModalLoading = true
            axios
                .post(
                    `/api/document/${this.selectedDocument.id}/new-owner`,
                    {
                        newDocumentOwner: this.newDocumentOwner,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${this.$store.getters.token}`,
                        },
                    }
                )
                .then((res) => {
                    this.changeDocumentOwnershipModal = false
                    this.changeDocumentOwnershipModalLoading = false
                })
        },
        getChain(check) {
            let originial = this.docDocuments.find((doc) => {
                return doc.id == check.parent_document_id
            })
            let chained = {
                final: check,
                stages: this.docDocuments.filter((doc) => {
                    return doc.parent_document_id == check.parent_document_id && doc.id != check.id && doc.hash != check.hash
                }),
                signatures: _.get(originial, "signatures"),
            }
            return chained
        },
        openSignatureChain(doc) {
            this.currentSignatureChain = doc
            this.chain = this.getChain(doc)
            this.showSignatureChain = true
        },
        closeSignatureChain() {
            this.chain = {}
            this.showSignatureChain = false
            this.currentSignatureChain = {}
        },
        pairedHash(item) {
            return this.docDocuments.find((doc) => {
                return doc.hash != "" && doc.hash === item.hash && doc.id != item.id
            })
        },
        fileex(filetype) {
            return `fa fa-${filetype}`
        },
        removeDocument(item) {
            this.$emit("deleteDocument", item)
            this.previewDocument = ""
            setTimeout(() => {
                this.getTrashed()
            }, 3000)
        },
        previewFolder(group) {
            this.previewDocument = ""
            this.preview = this.documents.get(group)
        },
        previewFile(file, group, index) {
            this.preview = ""

            $(".file-item").removeClass("active")
            this.$refs[`${group}-${index}`][0].classList.add("active")
            this.previewDocument = file
        },
        startDrag: (evt, item) => {
            evt.dataTransfer.dropEffect = "move"
            evt.dataTransfer.effectAllowed = "move"
            evt.dataTransfer.setData("itemID", item.id)
        },
        onDrop(evt, group) {
            const itemID = evt.dataTransfer.getData("itemID")
            const item = this.docDocuments.find((item) => item.id == itemID)

            if (item.document_type && item.document_type.document_type == group.toLowerCase()) return
            this.selectedDocument = item
            this.selectedGroup = group
            this.showDocumentTypeModel = true
        },
        changeDocumentTypeModal(item) {
            this.showDocumentTypeModel = true
            this.selectedDocument = item
        },
        changeDocumentType() {
            this.selectedDocument.document_type_id = this.newDocumentCategory.id
            if (this.renameDocument) {
                let cat = this.fileTypes.find((item) => {
                    return item.id == this.newDocumentCategory.id
                })
                if (cat.default_filename) {
                    this.selectedDocument.filename = `${cat.default_filename}.${this.selectedDocument.type}`
                    this.selectedDocument.name = cat.name
                }
            }

            this.$emit("changeFileType", {doc: this.selectedDocument})
            this.selectedDocument = {}
            this.newDocumentCategory = {}
            this.selectedGroup = ""
            this.showDocumentTypeModel = false
            this.renameDocument = true
        },
        handleChange(val) {
            if (val == "closeall") {
                this.folderView = true
                this.openFolder = 200
                this.preview = ""
                this.previewDocument = ""
                this.trashView = false
            } else {
                this.openFolder = val
            }
            $(".file-item").removeClass("active")
        },
        setStatus(status, item) {
            item.$attrs.document.status = status
            this.$emit("changeFileType", {doc: item.$attrs.document, status: true})
        },
        renameFilename(item) {
            item.name.split(".").pop()
            let name = item.name.split(".")[0]
            this.$prompt("", "Rename Document", {
                confirmButtonText: "Rename",
                cancelButtonText: "Cancel",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                inputPattern: /^[a-zA-Z0-9 ()_-]*$/,
                inputErrorMessage: "Only letters, numbers, spaces, parentheses, dashes and underscores are allowed",
                inputValue: item.name ? name : "",
            })
                .then(({value}) => {
                    this.rename(item, value)
                })
                .catch(() => {
                })
        },
        rename(item, value) {
            let endpoint = `/api/v2/applications/${this.$store.getters.initAppData.id}/documents/${item.id}`

            if (item.is_app_document) {
                endpoint = `/api/v2/applications/${this.$store.getters.initAppData.id}/app-document/${item.id}`
            }

            let res = axios
                .put(
                    endpoint,
                    {
                        filename: `${value}.${item.type}`,
                        name: value,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${this.$store.getters.token}`,
                        },
                    }
                )
                .then((res) => {
                    item.filename = res.data.file_name
                    item.name = res.data.name

                    this.$message({
                        message: "Renamed Document to: " + `${value}`,
                        type: "success",
                    })
                })
        },
        viewDocument(doc) {
            axios
                .get(
                    "/api/application/" +
                    this.$store.getters.initAppData.id +
                    "/finalise/documents/" +
                    doc.id +
                    "?is_app_document=" +
                    doc.is_app_document,
                    {
                        headers: {
                            Authorization: `Bearer ${this.$store.getters.token}`,
                        },
                    }
                )
                .then((res) => window.open(res.data))
        },
        uploadFileLine(e, doc) {
            let file = e.target.files[0]
            this.uploadLineFile({file: file, id: doc.id})
        },
        uploadPending(item) {
            if (!item.is_app_document) {
                let el = this.$refs["upload_field_" + item.id][0]
                el.click()
            }
        },
        getDocuments() {
            this.previewDocument = ""
        },
        async uploadLineFile(data) {
            try {
                // form data
                let headers = {
                    headers: {
                        Authorization: "Bearer " + this.$store.getters.token,
                        "Content-Type": "multipart/form-data",
                    },
                }
                let formData = new FormData()
                formData.append("file", data.file)
                let res = await axios.post(
                    "/api/application/conditioning/" + this.$store.getters.appId + "/document/" + data.id,
                    formData,
                    headers
                )
                this.previewDocument = ""
                this.$message({
                    message: "File Uploaded",
                    type: "success",
                })
            } catch (err) {
                console.error(err)
                this.$message({
                    message: "Upload Failed",
                    type: "error",
                })
            }
        },
        select(element) {
            if (!this.merge) return
            let el = this.$refs[element][0]
            el.click()
        },
        isSelected(item) {
            if (!this.merge.active) return
            return this.merge.items.find((doc) => {
                return doc.id === item.id
            })
        },
        mergeNow() {
            if (this.merge.items.length == 0) return
            this.merge.showMergeCompile = true
        },
        cancelMerge() {
            if (!this.merge.active) return
            this.merge.items = []
            this.merge.active = false
        },
        removeAt(index) {
            this.merge.items.splice(index, 1)
        },
        resetSigningRequestEmail() {
            this.sendSigningRequestModal = false
            this.sendSigningRequestEmail = false
        },
        async compileDocuments() {
            try {
                this.loading = true
                let headers = {
                    headers: {
                        Authorization: "Bearer " + this.$store.getters.token,
                    },
                }
                let res = axios.post(
                    `/api/v2/applications/${this.$store.getters.initAppData.id}/documents/merge`,
                    {
                        name: this.merge.name,
                        document_type_id: this.merge.newDocumentCategory.id,
                        documents: this.merge.items,
                        remove: this.merge.remove,
                    },
                    headers
                )

                this.merge.name = ""

                this.$message({
                    message: "Combining Documents, please wait",
                    type: "success",
                })

                setTimeout(() => {
                    if (this.merge.remove) {
                        this.$message({
                            message: "Documents moved to trash",
                            type: "success",
                        })
                    }
                    this.loading = false
                    this.merge.showMergeCompile = false
                    this.merge.items = []
                    this.merge.active = false
                    this.merge.remove = false
                    this.merge.newDocumentCategory = {}
                }, 5000)
            } catch (err) {
                console.error(err)
            }
        },
        getTrashed() {
            let headers = {
                headers: {
                    Authorization: "Bearer " + this.$store.getters.token,
                },
            }
            axios.get(`/api/applications/${this.$store.getters.initAppData.id}/documents/trash`, headers).then((res) => {
                this.trash = res.data
            })
        },
        restoreDocument(item) {
            let headers = {
                headers: {
                    Authorization: "Bearer " + this.$store.getters.token,
                },
            }
            axios
                .post(
                    `/api/applications/${this.$store.getters.initAppData.id}/documents/restore/${item.id}`,
                    {is_app_document: item.is_app_document},
                    headers
                )
                .then((res) => {
                    if (res.data.success) {
                        const itemIndex = this.trash.findIndex((doc) => {
                            return item.id == doc.id
                        })
                        this.trash.splice(itemIndex, 1)
                    }
                })
        },
    },
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';

.el-header {
    background-color: #b3c0d1;
    color: #333;
    line-height: 60px;
}

.el-aside {
    color: #333;
}

.file-preview {
    overflow-y: scroll;
    padding: 0.5rem;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.file-list {
    width: 100%;

    .file-wrapper {
        position: relative;
        width: 100%;

        .file-item {
            border: 1px dashed transparent;
            width: 100%;
            display: flex;
            align-items: center;
            padding: 7px;
            border-radius: 0.5rem;
            cursor: pointer;

            &.selected {
                border: 1px solid #5bbc2a;
                background-color: rgba(91, 188, 42, 0.08);
            }

            .icon-item {
                text-align: center;
                position: relative;
                flex: 0 0 50px;
                line-height: 0;
                margin-right: 20px;
                color: #f1f2f3;

                .fa-folder,
                .fa-file-image,
                .fa-file-pdf,
                .fa-folder-open {
                    font-size: 3.25em;
                }

                .fa-layers-text {
                    color: #2593ef;
                }
            }

            .item-name {
                display: block;
                color: #242b46;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                .name {
                    font-weight: 600;
                    user-select: text;
                    display: block;
                    font-size: 0.875em;
                    max-height: 48px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .item-length {
                    font-size: 0.75em;
                    font-weight: 400;
                    color: #667b90;
                    display: block;
                }
            }

            .actions {
                display: flex;
                justify-content: flex-end;
                align-items: center;

                .action {
                    margin-left: 1rem;

                    &.trash {
                        color: rgb(238, 65, 35);
                    }
                }
            }

            .showonhover {
                opacity: 0;
            }

            &:not(.folder) {
                &.grabbing {
                    cursor: grabbing !important;
                }

                &:hover,
                &:focus {
                    // background-color: #f9f9f9;
                    border-radius: 0.5rem;
                    background-color: #f5f5f5;

                    .icon-item {
                        &.success {
                            color: #67c23a;
                        }

                        &.warning {
                            color: #e6a23c;
                        }

                        &.danger {
                            color: #f56c6c;
                        }

                        .fa-layers-text {
                            color: transparent;
                        }
                    }

                    .showonhover {
                        opacity: 1;
                    }
                }
            }
        }

        &.active {
            .file-item {
                border-radius: 0.5rem;
                background-color: rgba(37, 147, 239, 0.26);

                .icon-item {
                    &.success {
                        color: #67c23a;
                    }

                    &.warning {
                        color: #e6a23c;
                    }

                    &.danger {
                        color: #f56c6c;
                    }

                    .fa-layers-text {
                        color: transparent;
                    }
                }
            }
        }
    }
}

.preview-panel {
    background-color: rgb(238, 241, 246);
    padding-bottom: 0px !important;
}
</style>
<style lang="scss">
.merge-item-count {
    & > sup {
        left: -50px !important;
        right: auto !important;
        top: 25px !important;
    }

    &.nilCount {
        sup {
            opacity: 0;
        }
    }
}

.trash-item-count {
    & > sup {
        left: -35px !important;
        right: auto !important;
        top: 16px !important;
    }

    &.nilCount {
        sup {
            opacity: 0;
        }
    }
}

.merge-shortcut-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px !important;

    & > button {
        flex-grow: 1;
        padding: 0.4rem;
        margin: 0 !important;
    }
}

// .is-merge {
//   color: #ffffff!important;
//   background-color: rgba(91, 188, 42, 0.9)!important;
// }

.name {
    &.pending {
        color: #999;
    }
}

.item-status {
    .el-tag {
        overflow: hidden;
        max-width: 170px;
        text-overflow: ellipsis;
    }
}

.document-types {
    max-width: 470px;
}

.document-panel {
    background: #fff;

    .el-collapse {
        border-top: 0px;
        border-bottom: 0px;
    }

    .el-collapse {
        .droppable {
            .el-collapse-item__header {
                border-color: #2493ef !important;
            }
        }
    }

    .el-collapse-item__header {
        background-color: #f7fafd;
        border-radius: 0.5rem;
        border: 2px dashed transparent !important;
        cursor: pointer;

        &.is-active,
        &:hover {
            background-color: #2593ef;
            color: #fff;
            cursor: pointer;

            .icon-item {
                .fa-layers-text {
                    color: #242b46;
                }
            }

            .item-name {
                .name {
                    font-weight: 600;
                    color: #fff;
                }
            }
        }
    }

    .el-collapse-item {
        margin-bottom: 0.5rem;

        &.is-active {
            .el-collapse-item__wrap {
                overflow-y: scroll !important;
                max-height: calc(900px - var(--file-preview-scoll));
                border-bottom: 0px;
                -ms-overflow-style: none;

                &::-webkit-scrollbar {
                    display: none;
                }

                .el-collapse-item__wrap {
                    border-bottom: 0px;
                }
            }
        }
    }
}

.multipane.document-panel.layout-v .multipane-resizer {
    margin: 0;
    left: 0;
    width: 20px;
    background: #eff1f5;
    height: auto;

    &:before {
        position: absolute;
        content: "";
        opacity: 0.5;
        background-color: #2593ef;
        width: 20px;
        height: 20px;
        top: calc(50% - 5px);
        left: -10px;
        border-radius: 50%;
    }
}

.multipane.document-panel.layout-h .multipane-resizer {
    margin: 0;
    top: 0;
    height: 2px;
    background: #eff1f5;
    width: auto;
}

.FileManager .el-tag {
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}
</style>
